import { assert_string_hash_sha256, assert_string_not_empty, assert_type_boolean, assert_type_enum, assert_type_string } from '@shared/asserts/utils_asserts';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { ENUM__image_color_mode } from '@shared/dto/generation/graph_invoke/_fields/image/_enums/ENUM__image_color_mode';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__color } from '../_enums/ENUM__color';
import { ENUM__image_orientation } from '../_enums/ENUM__image_orientation';

export class DTO__image_asset extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.IMAGE_ASSET;

  /*
   * STATIC METHODS
   */

  static get_map_by_hash(items: DTO__image_asset[]): MAP__serializable<string, DTO__image_asset> {
    let out = new MAP__serializable<string, DTO__image_asset>();

    for (let item of items) {
      out.set(item.hash_sha256_content, item);
    }

    return out;
  }

  /*
   * DB FIELDS
   */

  url_relative!: string;
  url_relative_small!: string;
  url_relative_watermark!: string;

  category!: ENUM__image_asset_category;

  hash_sha256_content!: string;

  image_size!: DTO__image_size;

  orientation!: ENUM__image_orientation;
  color_mode!: ENUM__image_color_mode;
  is_single_color!: boolean;
  single_color!: string;

  is_safe_for_work!: boolean;

  /*
   * PROPERTIES
   */
  get url_relative_latest() {
    return `${this.url_relative}?${this.updated_at}`;
  }

  get is_single_color_mask_empty() {
    return this.is_single_color && this.single_color == ENUM__color.MASK_EMPTY;
  }

  get is_single_color_mask() {
    return this.is_single_color && this.single_color == ENUM__color.MASK_ACTIVE;
  }

  get is_single_color_black() {
    return this.is_single_color && this.single_color == ENUM__color.BLACK;
  }

  get is_single_color_white() {
    return this.is_single_color && this.single_color == ENUM__color.WHITE;
  }

  /*
   * METHODS
   */
  constructor() {
    super();
    this.image_size = DTO__image_size.CREATE_STUB();

    //todo: uploaded and generated images - check with generator
    //todo: mb need change to status: unknown, safe, unsafe
    this.is_safe_for_work = true; //todo:remove
  }

  /*
   * ASSERTS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.category, ENUM__image_asset_category);

    assert_string_hash_sha256(this.hash_sha256_content);

    this.assert_image_params();

    this.assert_urls();
  }

  assert_image_params() {
    assert_type_enum(this.orientation, ENUM__image_orientation);
    assert_type_enum(this.color_mode, ENUM__image_color_mode);
    assert_type_boolean(this.is_single_color);
    assert_type_string(this.single_color);

    assert_type_boolean(this.is_safe_for_work);
  }

  assert_urls() {
    // todo: assert_string_url
    assert_string_not_empty(this.url_relative);
    assert_string_not_empty(this.url_relative_small);
    assert_string_not_empty(this.url_relative_watermark);
  }
}
